import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import {
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    withStyles,
} from '@material-ui/core';
import * as actions from '../../../sc-dashboard/UploadErasureData/store/uploadActions';

const styles = (theme) => ({
    root2: {
        flexGrow: 1,
        marginTop: theme.spacing(2),
        width: '80%',
        marginLeft: '3rem',
        marginRight: '3rem',
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: '80%',
        marginTop: theme.spacing(5),
        bottom: 15,
        marginLeft: theme.spacing(7),
    },
    formControl: {
        marginTop: theme.spacing(-3),
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(0.1),
        marginRight: theme.spacing(5),
        minWidth: 180,
    },
    formGroup: {
        marginTop: theme.spacing(-2),
        width: '100%',
    },
    dropdown: {
        width: '100%',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    errorMsg: {
        textAlign: 'center',
        color: 'red',
        fontWeight: 'bold',
    },
});

const StorageTypes = [
    {
        displayValue: 'HDD',
        value: 'hdd',
    },
    {
        displayValue: 'SSD',
        value: 'ssd',
    },
];

const CreateShreddedProductForm = (props) => {
    const { activeCustomerID, classes, translations, fetchOrder, fetchColli, handleSubmit, activeCustomer } = props;

    const initialValues = {
        ActiveCustomerID: activeCustomerID ?? null,
        OrderID: JSON.parse(activeCustomer?.Presets)?.OrderID ?? null,
        TransportColliID: JSON.parse(activeCustomer?.Presets)?.TransportColliID ?? null,
        ColliID: JSON.parse(activeCustomer?.Presets)?.ColliID ?? null,
        StorageType: '',
        StorageSize: '',
        SerialNumber: '',
        Vendor: '',
        ComponentModel: '',
        Shredded: true,
        ShreddedInfo: '',
    };

    const [logisticData, setLogisticData] = useState({
        collies: [],
        orders: [],
        selectedOrder: null,
    });

    useEffect(() => {
        const fetchData = async () => {
            let collies = await fetchColli(activeCustomerID);
            let orders = await fetchOrder(activeCustomerID);

            let selectedOrder = orders.find(
                (order) => order.value.toString() === JSON.parse(activeCustomer?.Presets)?.OrderID?.toString()
            );

            setLogisticData({
                collies: collies,
                orders: orders,
                selectedOrder,
            });
        };
        fetchData();
    }, [fetchOrder, fetchColli, activeCustomerID, activeCustomer]);

    const handleCreateClick = async (values) => {
        handleSubmit(values);
    };

    const handleOrderChange = (e, handleChange) => {
        handleChange(e);
        const orderID = e.target.value;
        setLogisticData({
            ...logisticData,
            selectedOrder: logisticData.orders.find((order) => order.value.toString() === orderID),
        });
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                await handleCreateClick(values);
                setSubmitting(false);
            }}
            validationSchema={Yup.object().shape({
                ActiveCustomerID: Yup.string().required(),
                OrderID: Yup.string().required(),
                TransportColliID: Yup.string().required(),
                ColliID: Yup.string().required(),
                StorageType: Yup.string().required(),
                StorageSize: Yup.string().required(),
                SerialNumber: Yup.string().required(),
                Vendor: Yup.string().required(),
                ComponentModel: Yup.string(),
                Shredded: Yup.string(),
                ShreddedInfo: Yup.string(),
            })}
        >
            {(formikProps) => {
                const { values, handleChange, isValid, errors, touched, isSubmitting, handleSubmit } = formikProps;

                return (
                    <div className={classes.root2}>
                        <form onSubmit={handleSubmit}>
                            <FormControl className={classes.dropdown}>
                                <InputLabel id="select_order">
                                    {translations['select_order'] || 'Select order'}
                                </InputLabel>
                                <Select
                                    labelId="select_order"
                                    id="select_order"
                                    name="OrderID"
                                    label={translations['order'] || 'Order'}
                                    error={!!(errors.OrderID && touched.OrderID)}
                                    margin={'dense'}
                                    placeholder={translations['select_order'] || 'Select order'}
                                    value={values?.OrderID || ''}
                                    onChange={(e) => handleOrderChange(e, handleChange)}
                                    fullWidth={true}
                                >
                                    {(logisticData?.orders || []).map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl className={classes.dropdown}>
                                <InputLabel id="select_transport_colli">
                                    {translations['select_transport_colli'] || 'Select transport colli'}
                                </InputLabel>
                                <Select
                                    labelId="select_transport_colli"
                                    id="select_transport_colli"
                                    name="TransportColliID"
                                    label={translations['transport_colli'] || 'Transport colli'}
                                    error={!!(errors.TransportColliID && touched.TransportColliID)}
                                    margin={'dense'}
                                    placeholder={translations['select_transport_colli'] || 'Select transport colli'}
                                    value={values?.TransportColliID || ''}
                                    onChange={handleChange}
                                    fullWidth={true}
                                >
                                    {(logisticData.selectedOrder?.TransportCollies || []).map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl className={classes.dropdown}>
                                <InputLabel id="select_colli">
                                    {translations['select_colli'] || 'Select colli'}
                                </InputLabel>
                                <Select
                                    labelId="select_colli"
                                    id="select_colli"
                                    name="ColliID"
                                    label={translations['colli'] || 'Colli'}
                                    error={!!(errors.ColliID && touched.ColliID)}
                                    margin={'dense'}
                                    value={values?.ColliID || ''}
                                    onChange={handleChange}
                                    fullWidth={true}
                                >
                                    {(logisticData?.collies || []).map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl className={classes.dropdown}>
                                <InputLabel id="select_storage_type">
                                    {translations['select_storage_type'] || 'Select storage type'}
                                </InputLabel>
                                <Select
                                    labelId="select_storage_type"
                                    id="select_storage_type"
                                    name="StorageType"
                                    label={translations['storage_type'] || 'Storage type'}
                                    error={!!(errors.StorageType && touched.StorageType)}
                                    margin={'dense'}
                                    placeholder={translations['select_storage_type'] || 'Select storage type'}
                                    value={values?.StorageType || ''}
                                    onChange={handleChange}
                                    fullWidth={true}
                                >
                                    {(StorageTypes || []).map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <TextField
                                name="StorageSize"
                                type="number"
                                value={values.StorageSize}
                                error={!!(errors.StorageSize && touched.StorageSize)}
                                onChange={handleChange}
                                placeholder={`${translations['storage_size'] || 'Storage size'} (GB)`}
                                label={`${translations['storage_size'] || 'Storage size'} (GB)`}
                                margin={'dense'}
                                fullWidth={true}
                            />

                            <TextField
                                name="SerialNumber"
                                value={values.SerialNumber}
                                error={!!(errors.SerialNumber && touched.SerialNumber)}
                                onChange={handleChange}
                                placeholder={translations['serial_number'] || 'Serial number'}
                                label={translations['serial_number'] || 'Serial number'}
                                margin={'dense'}
                                fullWidth={true}
                            />

                            <TextField
                                name="Vendor"
                                value={values.Vendor}
                                error={!!(errors.Vendor && touched.Vendor)}
                                onChange={handleChange}
                                placeholder={translations['vendor'] || 'Vendor'}
                                label={translations['vendor'] || 'Vendor'}
                                margin={'dense'}
                                fullWidth={true}
                            />

                            <TextField
                                name="ComponentModel"
                                value={values.ComponentModel}
                                onChange={handleChange}
                                placeholder={translations['component_model'] || 'Component model'}
                                label={translations['ComponentModel'] || 'Component model'}
                                margin={'dense'}
                                fullWidth={true}
                            />

                            <TextField
                                name="ShreddedInfo"
                                value={values.ShreddedInfo}
                                onChange={handleChange}
                                placeholder={translations['shredded_info'] || 'Shredded info'}
                                label={translations['shredded_info'] || 'Shredded info'}
                                margin={'dense'}
                                fullWidth={true}
                            />

                            <Button
                                className={classes.submit}
                                variant="contained"
                                type="submit"
                                disabled={!isValid || isSubmitting}
                            >
                                {isSubmitting ? (
                                    <CircularProgress size={24} />
                                ) : (
                                    translations['create_shredded_product'] ?? 'Create shredded product'
                                )}
                            </Button>
                        </form>
                    </div>
                );
            }}
        </Formik>
    );
};

const mapStateToProps = (state) => {
    return {
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        activeCustomer: state?.core?.login?.activeCustomer ?? null,
        translations: state?.translate?.translations?.activeTranslations ?? {},
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        uploadErasureData: (data, updateProgress) => dispatch(actions.uploadErasureData(data, updateProgress)),
        fetchOrder: (activeCustomerID) => dispatch(actions.fetchOrder(activeCustomerID)),
        fetchColli: (activeCustomerID) => dispatch(actions.fetchColli(activeCustomerID)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CreateShreddedProductForm));
